import React from 'react'
import { FEATURE_UC_IN_WEBREGISTER_LINE_ITEM } from '../../../../../constants'
import { getFeatureFromCache } from '../../../../../util/feature-cache'
import { LineItemDisplayFulfilment as LineItemDisplayFulfilmentUnified } from './LineItemDisplayFulfilment'
import { LineItemDisplayFulfilmentLegacy } from './LineItemDisplayFulfilmentLegacy'
import { LineItemDisplayFulfilmentProps } from './useLineItemDisplayFulfilmentModel'

export const LineItemDisplayFulfilment: React.FC<LineItemDisplayFulfilmentProps> = props => {
  const isUnifiedFulfilmentUiEnabled = getFeatureFromCache(
    FEATURE_UC_IN_WEBREGISTER_LINE_ITEM
  )

  return isUnifiedFulfilmentUiEnabled ? (
    <LineItemDisplayFulfilmentUnified {...props} />
  ) : (
    <LineItemDisplayFulfilmentLegacy {...props} />
  )
}
